var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.187,
    height: 12.89,
    viewBox: "0 0 17.187 12.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye_1_",
    "data-name": "eye (1)",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M17.059,8.859h0C16.43,7.484,13.965,3,8.594,3S.757,7.484.128,8.859a1.41,1.41,0,0,0,0,1.174c.629,1.374,3.094,5.857,8.465,5.857s7.837-4.484,8.465-5.859A1.409,1.409,0,0,0,17.059,8.859ZM8.594,13.742a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,8.594,13.742Z",
    transform: "translate(0 0)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(6 7)",
    fill: "#464646"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5d355938f88aa5e1f1006507576d0180.svg";
export { ForwardRef as ReactComponent };